import {Option} from './option.entity';


export class OptionPayment {
  id: number;

  date: Date;
  status: string;
  payment_id: string;

  amount: number;
  amount_gbp: number;

  options_fields: string;

  options: Option[];
  subscription_id?: number;
  user_id?: number;

  created_at: Date;
  updated_at: Date;
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/entities/option-payment.entity.ts